"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNextUniqueId = getNextUniqueId;
let nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}

//# sourceMappingURL=getNextUniqueId.js.map